















import { Component, Vue } from "vue-property-decorator";
@Component({
  components: {},
})
export default class Home extends Vue {
  public taskShow = false;
  public data = "";
  public show(data) {
    this.taskShow = true;
    this.data = "http://static.dhsf.xqhuyu.com/" + data;
  }

  public visibleChange(val) {
    if (val) return;
    this.data = "";
  }
}
